export enum ButtonActionEnum {
  SaveAsDraft = 0,
  Save = 1,
  SignOff = 2,
  Merge = 3,
  SaveAsPhrase = 4,
  SaveAsTemplate = 5,
  Clear = 6,
  Edit = 7,
  Delete = 8,
  Cancel = 9,
  DontSave = 10,
  SaveToIdb = 11,
}
